module.exports = __webpack_public_path__ + "assets/jetty.f290e03b.svg";